import { createFileRoute, redirect } from '@tanstack/react-router'
import { OpportunityRadarLayout } from '~/features/opportunity-radar/components'

const legacyMatchAlias = /^\/[^/]+\/radar\/(?:events|opportunities)\/[^/]+\/?$/
export const Route = createFileRoute('/$locale/radar')({
  beforeLoad: ({ location, params }) => {
    if (legacyMatchAlias.test(location.pathname))
      return
    throw redirect({ href: `/${params.locale}/matches`, replace: true })
  },
  component: OpportunityRadarLayout,
})
